import styled from 'styled-components'

import TreatmentCard, { Props as TreatmentCardProps } from '@/components/atomic/organisms/TreatmentCard/TreatmentCard'

export interface Props {
  treatments: TreatmentCardProps[]
}

const TreatmentCardList = ({ treatments }: Props): JSX.Element => {
  return (
    <StyledContainer $isPadding={treatments.length === 1}>
      {treatments.map((treatment) => (
        <StyledTreatmentCard {...treatment} $fullWidth={treatments.length === 1} key={treatment.id} />
      ))}
    </StyledContainer>
  )
}

const StyledContainer = styled.div<{ $isPadding: boolean }>`
  display: flex;
  width: 100%;
  box-sizing: border-box;
  overflow-x: auto;
  overflow-y: hidden;
  &::-webkit-scrollbar {
    display: none;
  }
  ${({ $isPadding }) => $isPadding && 'padding: 0 26px;'}
`
const StyledTreatmentCard = styled(TreatmentCard)<{ $fullWidth: boolean }>`
  flex-shrink: 0;
  width: ${({ $fullWidth }) => ($fullWidth ? '100%' : '288px')};
  margin-right: ${({ $fullWidth }) => ($fullWidth ? '0' : '16px')};
  box-sizing: border-box;
  word-break: break-all;

  &:first-of-type {
    margin-left: ${({ $fullWidth }) => ($fullWidth ? '0' : '26px')};
  }
`

export default TreatmentCardList
